import { useDispatch, useSelector } from "react-redux";
import { saveSession } from "../store/slice/auth.slice";
import { useNavigate } from "react-router-dom";
import { appConfig } from "../config/app.config";
import Cookies from 'js-cookie';
const useAuth = () => {
    const Navigate = useNavigate();
    const {user, isAuthenticated: isLoaggedIn} = useSelector((state) => state.auth)
    const dispatch = useDispatch();

    const onRefreshToken = (user) => {
        dispatch(saveSession(user))
        if (user?.role === "manager") {
            Navigate('/manager-dashboard'); // Navigate to manager-specific page
        } else if (user?.role === "employee") {
            Navigate('/landing-page'); // Navigate to user-specific page
        }else{
        // Navigate('/Superadmin-dashboard')
        Navigate('/view-org')
        }
    }
    console.log(isLoaggedIn, "isLoaggedIn");

    const logout = async () => {
        try {
            localStorage.clear();
            Cookies.remove(appConfig.tokenName)
            // const token = localStorage.getItem('authToken');
            // if (token) {
            //     // Optionally, send a request to invalidate the token on the backend
            //     await fetch('/api/logout', {
            //         method: 'POST',
            //         headers: {
            //             'Authorization': `Bearer ${token}`,
            //         },
            //     });
            // }
            dispatch(logout()); // Remove the user and authentication state
            Navigate('/'); // Redirect to the login page
        } catch (error) {
            console.error("Error logging out:", error);
        }
    };
    // const logout = () => {
    //     dispatch(logoutAction()); // Assuming you have a logout action
    //     Navigate('/login');
    //   };
    

    return {

        isLoaggedIn: isLoaggedIn,
        users: user,
        onRefreshToken,
        logout
    }
}

export default useAuth;